import { DDSTooltipProvider } from "../../Overlays/DDSTooltip/DDSTooltip";

export function DDSProvider({ children }: { children: React.ReactNode }) {
  return <DDSTooltipProvider>{children}</DDSTooltipProvider>;
}
